import cookies from "js-cookie";
import { parsePhoneNumber, getRegionCodeForCountryCode, PhoneNumber } from "awesome-phonenumber";
import moment from "moment";

export function json(text: string, lang?: "en" | "ar") {
  const currentLanguage = lang ?? (cookies.get("i18next") || "en");
  try {
    const parsedObject = JSON.parse(text);
    const lowerEntries = Object.entries(parsedObject).map(([k, v]) => [k.toLowerCase(), v]);
    const lowerObject = Object.fromEntries(lowerEntries);
    return lowerObject[currentLanguage === "en" ? "default" : "ar"] ?? text;
  } catch {
    return text;
  }
}

export function withDateFilter(fieldName = 'Createdate') {
  return (filterValue: string, selectedFilterOperation: string) => {
    if (filterValue && selectedFilterOperation === `=`) {
      return [
        [fieldName, 'GreaterThanOrEquals', moment.utc(filterValue)],
        'and',
        ['-R2-' + fieldName, 'Lessthan', moment(filterValue).add(1, 'days')],
        'date',
      ];
    } else {
      return [fieldName, selectedFilterOperation, filterValue];
    }
  }
}


export function jsonStringify(englishValue: string, arabicValue: string) {
  return JSON.stringify({ default: englishValue, ar: arabicValue });
}

export function validatePhone(mobileNumber: string, countryCode: string | number): PhoneNumber | boolean {
  const regionCode = getRegionCodeForCountryCode(+countryCode);
  const pn = parsePhoneNumber(mobileNumber, regionCode);
  return pn.isValid() && pn.isMobile() ? pn : false;
}

export const formatDate = (date: string | Date, { showTime } = { showTime: false }) => {
  return moment
    .utc(date)
    .local()
    .format("DD/MM/yyyy" + (showTime ? " - hh:mm a" : ""));
};

export const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString().split(",")[1]);
    reader.onerror = (error) => reject(error);
  });

export const base64Src = (data: string, type: string) => `data:${type};base64,` + data;

export const downloadFile = (file: any) => {
  const link = document.createElement("a");
  link.download = file?.realName;
  link.target = "_blank";
  link.href = file?.fullPath;
  link.click();
};

export const showDiscriminate = (str: any) => {
  switch (str) {
    case "Forever":
      return '{"default":"ForEver","ar":"دائما"}';
    case "Yearly":
      return '{"default":"Yearly","ar":"سنوى"}';
    case "Monthly":
      return '{"default":"Monthly","ar":"شهري"}';
    default:
      break;
  }
};